/* Vapor95 blog finder: search, subject filter and sort for the blog page (snippets/v95-blog-finder.liquid).
   With nothing picked, the normal paginated grid shows. Once a search, subject or sort is picked, every article
   is loaded from ?view=v95index (templates/blog.v95index.liquid), filtered here, and shown 12 at a time.
   The choice lives in the address (?q=&topic=&sort=) so a filtered view can be shared or bookmarked. */
(function () {
  var root = document.querySelector('[data-v95-bf]');
  if (!root) return;
  var section = root.closest('section') || document;
  var html = document.documentElement;
  var form = root.querySelector('[data-v95-bf-form]');
  var input = root.querySelector('[data-v95-bf-input]');
  var clearBtn = root.querySelector('[data-v95-bf-clear]');
  var sortSel = root.querySelector('[data-v95-bf-sort]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-topic]'));
  var status = root.querySelector('[data-v95-bf-status]');
  var grid = section.querySelector('[data-v95-bf-grid]');
  var pages = section.querySelector('[data-v95-bf-pages]');
  var results = section.querySelector('[data-v95-bf-results]');
  var more = section.querySelector('[data-v95-bf-more]');
  var moreBtn = section.querySelector('[data-v95-bf-more-btn]');
  var STEP = 12;
  var labels = {};
  chips.forEach(function (c) { var f = c.querySelector('.v95-bf-chip__face').cloneNode(true), n = f.querySelector('[data-n]'); if (n) n.remove(); labels[c.dataset.topic] = f.textContent.trim(); });

  // card look copied from the first server-rendered card so results match the grid exactly
  var proto = grid && grid.querySelector('li');
  var liClass = proto ? proto.className : 'lg:col-span-4';
  var mediaEl = proto && proto.querySelector('.media');
  var mediaClass = mediaEl ? mediaEl.className : 'media media--css-only default';
  var shadowEl = proto && proto.querySelector('.media') && proto.querySelector('.media').parentElement;
  var shadowClass = shadowEl ? shadowEl.className : 'mb-5 pb-media-shadow';

  var state = readUrl();
  var index = null, loading = null, shown = STEP, lastList = [];

  function readUrl() {
    var p = new URLSearchParams(location.search);
    return { q: (p.get('q') || '').slice(0, 100), topic: p.get('topic') || '', sort: p.get('sort') || '' };
  }
  function active() { return !!(state.q.trim() || state.topic || state.sort); }

  function writeUrl() {
    var p = new URLSearchParams(location.search);
    ['q', 'topic', 'sort', 'page'].forEach(function (k) { p.delete(k); });
    if (state.q.trim()) p.set('q', state.q.trim());
    if (state.topic) p.set('topic', state.topic);
    if (state.sort) p.set('sort', state.sort);
    var qs = p.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function load() {
    if (loading) return loading;
    var base = root.dataset.indexUrl;
    function get(page) {
      return fetch(base + (page > 1 ? '&page=' + page : ''), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    loading = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        var all = first.articles;
        more.forEach(function (m) { all = all.concat(m.articles); });
        all.forEach(function (a, i) {
          a.o = i;
          a.nt = ' ' + norm(a.t);
          a.nk = ' ' + norm((a.k || []).map(function (k) { return labels[k] || k; }).join(' '));
          a.ns = ' ' + norm(a.x + ' ' + a.s);
        });
        index = all;
        counts();
        return all;
      });
    }).catch(function (e) {
      loading = null;
      throw e;
    });
    return loading;
  }

  function counts() {
    var n = {};
    index.forEach(function (a) { (a.k || []).forEach(function (k) { n[k] = (n[k] || 0) + 1; }); });
    chips.forEach(function (c) {
      var el = c.querySelector('[data-n]');
      var v = c.dataset.topic ? (n[c.dataset.topic] || 0) : index.length;
      if (el) el.textContent = v;
      if (c.dataset.topic && !v) c.hidden = true;
    });
  }

  function search() {
    var terms = norm(state.q).split(' ').filter(Boolean);
    var list = index.filter(function (a) { return !state.topic || (a.k || []).indexOf(state.topic) > -1; });
    if (terms.length) {
      list = list.filter(function (a) {
        var score = 0;
        for (var i = 0; i < terms.length; i++) {
          var t = terms[i], hit = 0;
          var w = ' ' + t;   // words that start with the term: "mall" finds malls, not "small"
          if (a.nt.indexOf(w) > -1) hit = a.nt.indexOf(w + ' ') > -1 || a.nt.slice(-w.length) === w ? 10 : 7;
          else if (a.nk.indexOf(w) > -1) hit = 4;
          else if (a.ns.indexOf(w) > -1) hit = 1;
          if (!hit) return false;
          score += hit;
        }
        a.score = score;
        return true;
      });
    }
    var sort = state.sort || (terms.length ? 'match' : '');
    list.sort(function (x, y) {
      if (sort === 'old') return x.d < y.d ? -1 : x.d > y.d ? 1 : y.o - x.o;
      if (sort === 'match' && terms.length && y.score !== x.score) return y.score - x.score;
      return x.d > y.d ? -1 : x.d < y.d ? 1 : x.o - y.o;
    });
    return list;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function src(url, w) { return url.replace(/([?&])width=\d+/, '$1width=' + w); }

  function card(a) {
    var img = '';
    if (a.i) {
      var set = [350, 600, 900].map(function (w) { return src(a.i, w) + ' ' + w + 'w'; }).join(', ');
      img = '<div class="' + esc(shadowClass) + '"><div class="' + esc(mediaClass) + '">' +
        '<img src="' + esc(a.i) + '" srcset="' + esc(set) + '" sizes="(min-width: 990px) 33vw, 100vw" alt="' + esc(a.a) +
        '" loading="lazy" decoding="async" class="media__styled-element"></div></div>';
    }
    var kick = (a.k || []).map(function (k) { return labels[k] || k; }).join(' / ');
    return '<li class="' + esc(liClass) + '"><div class="relative text-center">' + img +
      (kick ? '<p class="v95-bf-kicker">' + esc(kick) + '</p>' : '') +
      '<h2 class="font-heading heading-secondary"><a href="' + esc(a.u) + '">' + esc(a.t) +
      '<span class="absolute left-0 top-0 z-10 block h-full w-full"></span></a></h2>' +
      '<div class="rte mt-2.5"><p>' + esc(a.x) + '</p></div></div></li>';
  }

  function paint() {
    input.value !== state.q && (input.value = state.q);
    clearBtn.hidden = !state.q;
    sortSel.value = state.sort;
    chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.topic === state.topic)); });

    if (!active()) {
      html.classList.remove('v95-bf-pending', 'v95-bf-on');
      results.hidden = true; more.hidden = true; results.innerHTML = '';
      status.textContent = '';
      return;
    }
    if (!index) {
      status.textContent = 'Loading articles...';
      load().then(paint, function () {
        html.classList.remove('v95-bf-pending', 'v95-bf-on');
        status.textContent = 'Search is not loading right now. Press Enter to search the whole store instead.';
      });
      return;
    }
    var list = search();
    lastList = list;
    html.classList.remove('v95-bf-pending');
    html.classList.add('v95-bf-on');
    results.hidden = false;
    results.innerHTML = list.slice(0, shown).map(card).join('');
    more.hidden = list.length <= shown;

    var where = state.topic ? ' in ' + (labels[state.topic] || state.topic) : '';
    var what = state.q.trim() ? ' for "' + state.q.trim() + '"' : '';
    status.textContent = list.length
      ? '> ' + list.length + (list.length === 1 ? ' article' : ' articles') + what + where
      : '> No articles' + what + where + '. Try another word or pick All.';
  }

  function update(change) {
    for (var k in change) state[k] = change[k];
    shown = STEP;
    writeUrl();
    paint();
  }

  var t;
  input.addEventListener('input', function () {
    clearTimeout(t);
    var v = input.value;
    clearBtn.hidden = !v;
    t = setTimeout(function () { update({ q: v }); }, 160);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && input.value) { e.preventDefault(); clearTimeout(t); update({ q: '' }); }
  });
  form.addEventListener('submit', function (e) {
    if (index || loading) { e.preventDefault(); clearTimeout(t); update({ q: input.value }); input.blur(); }
  });
  clearBtn.addEventListener('click', function () { clearTimeout(t); update({ q: '' }); input.focus(); });
  sortSel.addEventListener('change', function () { update({ sort: sortSel.value }); });
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      update({ topic: c.dataset.topic === state.topic ? '' : c.dataset.topic });
    });
  });
  moreBtn.addEventListener('click', function () {
    var first = shown;
    shown += STEP;
    results.innerHTML = lastList.slice(0, shown).map(card).join('');
    more.hidden = lastList.length <= shown;
    var next = results.children[first] && results.children[first].querySelector('a');
    if (next) next.focus({ preventScroll: true });
  });
  window.addEventListener('popstate', function () { state = readUrl(); shown = STEP; paint(); });

  // fetch the index early (idle time, or the moment someone reaches for the toolbar) so chips show counts
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
    root.addEventListener(ev, function () { load().catch(function () {}); }, { once: true, passive: true });
  });
  paint();

  function prefetch() { load().catch(function () {}); }
  if (window.requestIdleCallback) window.requestIdleCallback(prefetch, { timeout: 6000 });
  else setTimeout(prefetch, 2500);
})();
